import { GoLink, sectionTitle } from "@/features/portal/components/portal-ui";
import { COACH_APP_URL } from "@/features/portal/constants/coach-app";
import { m } from "@/paraglide/messages.js";

/*
  The one line of selling on this page, and it points away from it: a coach who lands here by
  accident should be told where their own app is, not shown a client sign-in twice.
*/
export const ForCoaches = () =>
  COACH_APP_URL ? (
    <div className="mt-16 rounded-[32px] border border-border bg-linear-to-t from-[var(--site-fog)] via-[var(--site-wash)] to-background px-5 py-16 text-center md:mt-[104px] md:py-[84px]">
      <h2 className={sectionTitle}>
        {m.portal_coach_title()}
        <br />
        {m.portal_coach_title_tail()}
      </h2>
      <p className="mx-auto mt-3.5 max-w-[420px] text-muted-foreground">{m.portal_coach_body()}</p>
      <GoLink to={COACH_APP_URL} external className="mt-6">
        {m.portal_coach_cta()}
      </GoLink>
    </div>
  ) : null;
